import { create } from 'zustand';

/**
 * Mobile/tablet drawer open state (below md).
 * Persistent sidebar at md+ does not use this store.
 */
type SideMenuStore = {
  show: boolean;
  open: () => void;
  hide: () => void;
  toggle: () => void;
};

const useSideMenuStore = create<SideMenuStore>(set => ({
  show: false,
  open: () => set({ show: true }),
  hide: () => set({ show: false }),
  toggle: () => set(s => ({ show: !s.show })),
}));

export default useSideMenuStore;
